import { HelpBlock as BootstrapHelpBlock } from "react-bootstrap";
import styled, { css } from "styled-components";
const HelpBlock = styled(BootstrapHelpBlock)(
  ({ theme }) => css`
    display: block;
    margin-top: 5px;
    margin-bottom: 10px;
    color: ${theme.colors.text.secondary};
  `
);
export default HelpBlock;
